import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BbChartComponent } from './bb-chart/bb-chart.component';
import { IconsModule } from '../icons/icons.module';

@NgModule({
    declarations: [BbChartComponent],
    exports: [BbChartComponent],
    imports: [CommonModule, IconsModule]
})
export class BbChartsModule {}
